import { Image, Box, Separator, Flex } from '@chakra-ui/react';
import { Heading } from 'components/ui';

export const SupportedConditions = () => {
  return (
    <>
      <Separator
        w={'80%'}
        mx="auto"
        my={10}
        display={{ base: 'block', xl: 'none' }}
      />
      <Flex
        maxW="1200px"
        w={{ base: '100%', lg: '80%' }}
        mx={'auto'}
        direction={{ base: 'column', xl: 'row' }}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Box w={{ base: '90%', xl: '30%' }}>
          <Heading
            color={'secondary.500'}
            fontWeight={400}
            textAlign={{ base: 'center', xl: 'left' }}
            fontSize={{ base: '3xl', xl: '4xl' }}
          >
            Support For Digestive Conditions & Symptoms
          </Heading>
        </Box>
        <Image
          src={'/conditions.gif'}
          w={{ base: 390, md: 707 }}
          h={{ base: 200, md: 391 }}
          mt={10}
          mb={{ base: '70px', lg: 0 }}
          objectFit="cover"
          rounded={'lg'}
          alt="Conditions supported by Ayble"
        />
      </Flex>
    </>
  );
};
